export enum PatientLoginType {
  Local = 1,
  Inera = 2
}
